import React from 'react'

 const TripleAnimation = () => {
  return (
    <div>TripleAnimation</div>
  )
}
export default TripleAnimation;
